import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@biome-design-system/ui/Link';

import {
  type Log,
  type SearchSuggestion,
  type GetUpdatedSearch
} from 'Src/types';

interface SuggestionLinkProps {
  suggestion: SearchSuggestion;
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
}

export const SuggestionLink = ({
  suggestion,
  getUpdatedSearch,
  log
}: SuggestionLinkProps) => {
  const handleOnClick = (): void => {
    log('user_action.search_results.spell_suggestion_clicked', {
      suggestion: suggestion.display_text,
      suggestion_type: suggestion.display_search_type
    });
  };

  return (
    <Link
      component={RouterLink}
      data-action="suggestion"
      onClick={handleOnClick}
      to={getUpdatedSearch(suggestion.query_modifications)}
      sx={(theme) => ({
        fontWeight: theme.typography.fontWeightBold
      })}
    >
      {suggestion.display_text}
    </Link>
  );
};
